import React from 'react';
import classNames from 'classnames';
import './wave-animation.scss';

export enum WaveModes {
	LITTLE = 'little-fill',
	HALF = 'half-fill',
	FULL = 'full-fill',
	HIDE = 'hide-fill'
}

export enum WaveColors {
	ORANGE = 'orange-background',
	RED = 'red-background',
	YELLOW = 'yellow-background',
	GREEN = 'green-background'
}

interface Props {
	content: string | JSX.Element;
	waveMode: WaveModes;
	waveColor: WaveColors;
}

const WaveAnimation: React.FC<Props> = ({ content, waveMode, waveColor }: Props) => {
	return (
		<div className="wave-container">
			<div className={classNames('water-effect', waveMode)}>
				<div
					className={classNames('waves', waveColor, {
						'hide-water': !content
					})}
				/>
				<div className="water" />
			</div>
			<div className="wave-content">{content}</div>
		</div>
	);
};
export default WaveAnimation;
